import { createStrings } from '@utils/local';

export const bookingInquiryProfitStrings = createStrings({
  ja: {
    invoice: '請求',
    payment: '支払',
    invoiceTaxExcludedAmount: '税抜請求総額',
    invoiceTaxAmount: '預り消費税',
    invoiceTatekaeAmount: '請求立替金額',
    paymentTaxExcludedAmount: '税抜支払総額',
    paymentTaxAmount: '支払消費税',
    paymentTatekaeAmount: '支払立替金額',
    total: '合計',
    profit: '利益',
    sales: '売上',
    grossProfit: '粗利',
  },
});
